import { createCache, initializeSocket, send, createOnmessage, utoa, tryJSONParse } from "./socketHelpers";
import { Operations, Contexes } from "./constants";
import { Search, WaitingResponses, ExpertResult } from "../types";
import { websocketClURL } from "../settings";
import { initializeSessionKey } from "./DataService";

const waitingResponse: WaitingResponses<any> = {};

const searchCache = createCache();

const createExpertSearch = (waitingResponse: WaitingResponses<any>) =>
    (socket: WebSocket) =>
        <ExpertResult>(argumentStr: string): Promise<Search<ExpertResult>> => {
            // API demands request to be strings with strict ordering
            const msgStr = `{"op":"${Operations.search}","ctx":"${Contexes.topaasiAsiantuntija}","query":"${utoa(argumentStr)}"}`;
            const msg = JSON.parse(msgStr);
            const matchResponseToCallback = (resp: Search<ExpertResult>) => {
                const respObj = tryJSONParse(resp as unknown as string);
                return respObj.ctx === msg.ctx &&
                    respObj.query.toLowerCase() === argumentStr.toLowerCase();
            };

            return new Promise((resolve, reject) => {
                const callback = (data: Search<ExpertResult>) => {
                    const msgString = JSON.stringify(msg);
                    searchCache.add(msgString, data);
                    resolve(data);
                };
                const msgString = JSON.stringify(msg);
                const cached = searchCache.get(msgString);

                cached ?
                    callback(cached.response as Search<ExpertResult>) :
                    send(
                        socket,
                        callback,
                        matchResponseToCallback,
                        msg,
                        waitingResponse,
                        reject,
                        msgStr
                    );
            });
        };

type search<T> = (argumentStr: string) => Promise<Search<T>>

export interface ISearchService {
    socket: WebSocket,
    searchExpert: search<ExpertResult[]>
}

export const initializeSearch = (sessionKey: string): Promise<ISearchService> =>
    new Promise((resolve, reject) => {
        const callback = async (socket: WebSocket) => {
            // No need to wait for response, the session-key is not used for following websocket messages
            // This was kept so backend logic does not break: always start with 'auth' message, it might be used for logging
            initializeSessionKey(
                socket,
                () => {},
                sessionKey,
            );

            resolve({
                socket,
                searchExpert: createExpertSearch(waitingResponse)(socket)
            });
        };

        initializeSocket(
            callback,
            createOnmessage(waitingResponse),
            websocketClURL,
            reject
        );
    });

export const forTests = {
    createExpertSearch
};
